import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute,NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {
  
  private idProducto:number;
  private sub: any;
  image:string;

  constructor(private router:Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
    });

    this.sub = this.route.params.subscribe(params => {
      this.idProducto = params['id'];
      this.image = './../../assets/img/'+ this.idProducto +'.jpeg'
    });
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/lgh/Documents/apps/editorial/src/app/product/product.component.ts